import React, { FC } from 'react';
import Div100vh from 'react-div-100vh';
import { ARViewer } from './feature/ARViewer/ARViewer';
import { ARViewerModel } from './feature/ARViewer/model/ARViewerModel';
import { useUrlParams } from './hooks/useUrlParams';
import modelData from './model/modelData.json';

type UrlParams = {
  id: string,
  animal: string,
  lang: string
}

const App: FC = () => {
  const params = useUrlParams<UrlParams>();
  const modelDataJson = JSON.stringify(modelData);
  const { animals } = JSON.parse(modelDataJson);

  const { animal } = params;
  const lang = params.lang || 'de';
  const model: ARViewerModel = animals[animal];

  if (!animal) {
    return (
      <Div100vh>
        <div>Animal not found</div>
      </Div100vh>
    );
  }

  return (
    <Div100vh>
      <ARViewer model={model} lang={lang} animal={animal} />
    </Div100vh>
  );
};

export default App;
